import React, { ForwardRefRenderFunction } from 'react';
import { Paper } from '@mui/material';
import { PdfA4ToolProps, PdfA4ToolRef } from '@/components/pdfTool/types';

const PdfA4Tool:
    ForwardRefRenderFunction<PdfA4ToolRef, PdfA4ToolProps> = (props, ref) => {
      const { PdfPaperId, image, children, className } = props;
      return (
        <Paper
            className={className}
            id={PdfPaperId}
            sx={{
              backgroundImage: image ? `url(${image})` : 'none', // 如果 image 存在，则设置背景图，否则不设置
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              height: '297mm', // A4 高度： 297mm
              width: '210mm', // A4 宽度： 210mm
              pageBreakAfter: 'always',
              position: 'relative',
            }}
        >
            {children} {/* 渲染外部传入的节点 */}
        </Paper>
      );
    };

export default PdfA4Tool;
